/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useActions } from 'common/hooks/useActions';
import { ReactSVG } from 'react-svg';
import { Switch } from 'antd';
import { useParams, useNavigate } from 'react-router';
import { toast } from 'common/helpers/toastConfig';
import Loader from 'components/loader';

import * as S from './styles';

interface ICustoms {
  selectedOptions: any;
  btnTitle?: string;
  title: any;
  category: string;
  image: string | null;
  activeStatus: boolean;
  values?: any;
}

type selectItem = {
  UpdatedAt: string;
  createdAt: string;
  id: number;
  isActive: boolean;
  optionType: string;
  title: string;
};

const Customization: React.FC<ICustoms> = ({ selectedOptions, btnTitle, title, category, activeStatus, values }) => {
  const [selectedItems, setSelectedItems] = useState<selectItem[]>([]);
  const [addedItems, setAddedItems] = useState<any[]>([]);
  const [filteredList, setFilteredList] = useState<any>();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 9999,
    keyword: '',
    type: ''
  });
  const [loading, setLoading] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  const { CustomList }: any = useTypedSelector((state) => state.Cafeteria);

  const {
    menuCustomizationListRequestAction,
    cafeteriaCreateMenuManagementRequestAction,
    menuManagementUpdateRequestAction
  } = useActions();

  const itemSelectHandler = (item: selectItem, isChecked: boolean) => {
    if (isChecked) {
      setSelectedItems((prev) => [...prev, item]);
      return;
    }
    setSelectedItems((prev) => prev.filter((selected) => selected.id !== item.id));
  };

  const fetchData = () => {
    menuCustomizationListRequestAction(meta);
  };

  const handleFilter = (field: string, val: string | number) => {
    setMeta({ ...meta, page: 1, [field]: val });
  };

  const filterData = (dataList: any, selectedItems: any): any => {
    const selectedIds = selectedItems.map((item: any) => item.id);

    return dataList.filter((item: any) => !selectedIds.includes(item.id));
  };

  const addNewItemHandler = () => {
    const newItems = selectedItems
      .filter((item) => !addedItems?.some((addedItem: any) => addedItem.id === item.id))
      .map((item) => ({
        ...item,
        isActiveForThisItem: false
      }));

    setAddedItems((prev) => [...(prev || []), ...newItems]);
  };

  const deleteItemHandler = (itemId: number) => {
    const itemToDelete = addedItems.find((item: any) => item.id === itemId);

    if (itemToDelete) {
      const newAddedItems = addedItems.filter((item: any) => item.id !== itemId);

      const itemExistsInFilteredList = filteredList.some((item: any) => item.id === itemId);

      if (!itemExistsInFilteredList) {
        setFilteredList((prevFilteredList: any) => [...prevFilteredList, itemToDelete]);
      }

      setAddedItems(newAddedItems);

      setSelectedItems((prevSelectedItems: any) => prevSelectedItems.filter((item: any) => item.id !== itemId));
    }
  };

  const submitHandler = (kind: string) => {
    if (!category) {
      toast({ model: 'error', message: 'Please choose a category' });
      return;
    }

    if (values.imageName?.length < 1 && kind === 'Create') {
      toast({ model: 'error', message: 'There is no image uploaded' });
      return;
    }

    if (title?.find((t: any) => t.language === 'en')?.translate.length < 1) {
      toast({ model: 'error', message: 'English Title is necessary' });
      return;
    }

    if (title?.find((t: any) => t.language === 'ar')?.translate.length < 1) {
      toast({ model: 'error', message: 'Arabic Title is necessary' });
      return;
    }

    let menuOptions: any = [];
    if (addedItems?.length > 0) {
      menuOptions = addedItems?.map((item) => ({
        id: item.id,
        isActive: item.isActiveForThisItem
      }));
    }

    if (kind === 'Create') {
      setLoading(true);
      const requestBody = {
        translations: title,
        status: `${activeStatus}`,
        category: category,
        image: values.imageName,
        ...(menuOptions.length > 0 && { menuOptions })
      };
      cafeteriaCreateMenuManagementRequestAction(
        requestBody,
        () => navigate('/panel/cafeteria/menu-management'),
        () => setLoading(false)
      );
      return;
    }

    if (kind === 'Update') {
      setLoading(true);
      const requestBody = {
        id: params?.id,
        translations: title,
        status: activeStatus,
        imageName: values.name,
        ...(menuOptions.length > 0 && { menuOptions })
      };
      menuManagementUpdateRequestAction(
        requestBody,
        () => navigate('/panel/cafeteria/menu-management'),
        () => setLoading(false)
      );
      return;
    }
  };

  useEffect(() => {
    if (CustomList?.data?.list) {
      const filtered = selectedOptions ? filterData(CustomList?.data?.list, selectedOptions) : CustomList?.data?.list;

      setFilteredList(filtered);
    }
  }, [CustomList, selectedOptions]);

  useEffect(() => {
    fetchData();
  }, [meta]);

  useEffect(() => {
    if (selectedOptions && params?.id) {
      setAddedItems(selectedOptions);
      return;
    }
    setAddedItems([]);
  }, [selectedOptions, params?.id]);

  return (
    <>
      <S.Container>
        <S.Title>Customization</S.Title>

        <S.ListContainer>
          <S.CustomsList>
            <h4>Customizations List</h4>

            <S.SearchBox>
              <S.Icon>
                <ReactSVG
                  src={'/icons/search-normal.svg'}
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', `22px`);
                    svg.setAttribute('height', `22px`);
                  }}
                />
              </S.Icon>

              <S.SearchInput
                type="text"
                placeholder="Search..."
                onChange={(e: any) => handleFilter('keyword', e.target.value)}
              />
            </S.SearchBox>

            <S.CustomItemsContainer>
              {filteredList && filteredList.length > 0 ? (
                filteredList.map((item: any) => (
                  <S.CustomItem key={item?.id}>
                    <div>
                      <S.CustomCheckbox
                        checked={selectedItems.some((selected) => selected.id === item.id)}
                        onChange={(e) => itemSelectHandler(item, e.target.checked)}
                      />
                      <h5>{item?.title}</h5>
                      <p>{`(${item?.optionType === 'SINGLE_SELECT' ? 'Single Select' : 'Yes/No'})`}</p>
                    </div>
                    {item?.isActive ? null : <p>Inactive</p>}
                  </S.CustomItem>
                ))
              ) : (
                <p>No available customizations</p>
              )}
            </S.CustomItemsContainer>

            <S.AddMenuBtn onClick={addNewItemHandler}>{`Add to ${btnTitle ? btnTitle : 'Menu Item'}`}</S.AddMenuBtn>
          </S.CustomsList>

          <S.SelectedList>
            <h4>Added Customization</h4>
            <p>*The disabled (dimmed) items in the list have been disabled from the Customizations section.</p>

            <S.SelectedItemsList>
              {addedItems?.map((item: any) => (
                <S.SelectedItem key={item.id} style={{ borderColor: item?.isActive ? undefined : '#E1DFEC80' }}>
                  <h5 style={{ color: item?.isActive ? undefined : '#959aa3' }}>{item.title}</h5>
                  <div>
                    <Switch
                      size="small"
                      style={{
                        backgroundColor: item?.isActiveForThisItem ? '#1DBAAF' : '#707070'
                      }}
                      checked={item?.isActiveForThisItem}
                      onChange={() => {
                        setAddedItems((prev) =>
                          prev.map((addedItem) =>
                            addedItem.id === item.id
                              ? { ...addedItem, isActiveForThisItem: !item?.isActiveForThisItem }
                              : addedItem
                          )
                        );
                      }}
                    />

                    <ReactSVG
                      src="/icons/stroke/trash.svg"
                      beforeInjection={(svg) => {
                        svg.setAttribute('stroke', `#FF6464`);
                        svg.setAttribute('width', `22px`);
                        svg.setAttribute('height', `22px`);
                        svg.setAttribute('cursor', `pointer`);
                      }}
                      onClick={() => deleteItemHandler(item.id)}
                    />
                  </div>
                </S.SelectedItem>
              ))}
            </S.SelectedItemsList>
          </S.SelectedList>
        </S.ListContainer>
      </S.Container>

      <S.ButtonContainer>
        <S.Button
          type="button"
          onClick={() => !loading && submitHandler(params?.id ? 'Update' : 'Create')}
          style={{ cursor: loading ? 'default' : 'pointer' }}
        >
          {loading ? <Loader bg_color="#fff" /> : params?.id ? 'Update' : 'Create'}
        </S.Button>
      </S.ButtonContainer>
    </>
  );
};

export default Customization;
